import makeClasses from './SwitchModeIOS.style';

import type { SwitchModeIOSProps } from './switchModeIOS.model';

export function SwitchModeIOS(props: SwitchModeIOSProps) {
  const {
    id,
    name,
    checked = false,
    disabled = false,
    color = 'primary',
    stopPropagation = false,
    onCheck,
  } = props;

  const _classes = makeClasses({ checked, color });

  return (
    <div
      className={_classes.container}
      onClick={e => stopPropagation && e.stopPropagation()}
    >
      <input
        id={id}
        name={name}
        type='checkbox'
        checked={checked}
        disabled={disabled}
        onChange={event => onCheck?.(event.target.checked)}
        className={_classes.checked}
      />
      <label
        htmlFor={id}
        className={_classes.label}
        data-is-disabled={disabled}
      />
    </div>
  );
}
